'use strict';require('../../style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/activity-indicator/style/css.web.js
// module id = 273
// module chunks = 0